import React from 'react';

export const LABEL = {
    BOOK_PERFORMANCE: 'Book Performance',
    READING_ACCURACY: 'Reading Accuracy',
    READING_FLUENCY: 'Reading Fluency',
    READING_COMP: 'Reading Comp',
    WRITTEN_COMP: 'Written Comp',
    OBSERVATIONAL: 'Observational',
    ONLINE: 'Online',
    N_LABEL: 'N',
    F_LABEL: 'F',
    FICTION: 'Fiction',
    NON_FICTION: 'Nonfiction',
    PROFICIENT_LABEL: 'P',
    NOT_PROFICIENT_LABEL: 'NP',
    WCPM: 'wcpm',
    RETELL: 'Retell',
    RECALL: 'Recall',
    RETELL_OR_RECALL: 'Retell/Recall',
    RETELLING: 'Retelling',
    INFORMATIONAL: 'Informational',
    LITERARY: 'Literary',
    READING_RECORD: 'Reading Record',
    COMPREHENSION: 'Comprehension',
    LANGUAGE_WRITING_GRAMMAR_SPELLING: 'Language, Writing, Grammar, Spelling (Optional)',
    READING_TRANSCRIPT: 'Reading Transcript',
};

export const PERFORMANCE_LEVEL = {
    FRUSTRATIONAL: 'FRUSTRATIONAL',
    INSTRUCTIONAL: 'INSTRUCTIONAL',
    INDEPENDENT: 'INDEPENDENT',
    PROFICIENT: 'PROFICIENT',
    NOT_PROFICIENT: 'NOT_PROFICIENT',
    IN_PROGRESS: 'IN_PROGRESS',
};

export const PERFORMANCE_LEVELS = [
    {
        key: PERFORMANCE_LEVEL.FRUSTRATIONAL,
        abbreviation: 'FRU',
        label: 'Fru.',
        title: 'Frustrational',
    },
    {
        key: PERFORMANCE_LEVEL.INSTRUCTIONAL,
        abbreviation: 'INS',
        label: 'Ins.',
        title: 'Instructional',
    },
    {
        key: PERFORMANCE_LEVEL.INDEPENDENT,
        abbreviation: 'IND',
        label: 'Ind.',
        title: 'Independent',
    },
    {
        key: PERFORMANCE_LEVEL.PROFICIENT,
        abbreviation: LABEL.PROFICIENT_LABEL,
        label: 'P.',
        title: 'Proficient',
    },
    {
        key: PERFORMANCE_LEVEL.NOT_PROFICIENT,
        abbreviation: LABEL.NOT_PROFICIENT_LABEL,
        label: 'NP.',
        title: 'Not Proficient',
    },
    { key: PERFORMANCE_LEVEL.IN_PROGRESS, title: 'In progress' },
];

export const BOOK_TYPE = {
    NON_FICTION: 'NON_FICTION',
    FICTION: 'FICTION',
};

export const BOOK_GENRES = [
    { key: BOOK_TYPE.FICTION, label: LABEL.F_LABEL, title: LABEL.FICTION },
    { key: BOOK_TYPE.NON_FICTION, label: LABEL.N_LABEL, title: LABEL.NON_FICTION },
    { key: LABEL.FICTION, label: LABEL.F_LABEL, title: LABEL.FICTION },
    { key: LABEL.NON_FICTION, label: LABEL.N_LABEL, title: LABEL.NON_FICTION },
    { key: LABEL.LITERARY, label: LABEL.F_LABEL, title: LABEL.FICTION },
    { key: LABEL.INFORMATIONAL, label: LABEL.N_LABEL, title: LABEL.NON_FICTION },
];

export const TRC_SCORE = {
    PS: 'PS',
    PC: 'PC',
    RB: 'RB',
    FRU: 'FRU',
    LESS_THAN_PC: '<PC',
};

export const LIST = {
    PC_RB_LIST: [TRC_SCORE.LESS_THAN_PC, TRC_SCORE.PC, TRC_SCORE.RB],
};

export const RESULT_TYPE = {
    READING_RECORD: 'READING_RECORD',
    READING_BEHAVIORS: 'READING_BEHAVIORS',
};

export const SPECIAL_SCORE_TITLE_MAPPER = {
    PC: 'Print Concepts',
    RB: 'Reading Behaviors',
};

export const QUESTION_TYPE = {
    IMPLICIT: 'IMPLICIT',
    EXPLICIT: 'EXPLICIT',
};

export const KEY = {
    RUBRIC_TYPE: 'RUBRIC_TYPE',
    QUESTIONS_TYPE: 'QUESTIONS_TYPE',
};

export const ID = {
    READING_RECORD: 'reading-record',
    COMPREHENSION: 'comprehension',
    LANGUAGE_WRITING_GRAMMAR_SPELLING: 'language-writing-grammar-spelling',
    SPECIAL: 'special',
    READING_TRANSCRIPT: 'reading-transcript',
};

export const CLASSNAMES = {
    REPEAT_CENTER_ICON_CLASS: 'repeat-center-icon',
};

export const MSV = ['M', 'S', 'V'];

export const TRC_LEGEND_CONTENT = (
    <div className="legend-wrapper">
        <div className="key-item left substitution" />
        <div className="key-item right insert" />
        <div className="key-item left omit" />
        <div className="key-item right told" />
        <div className="key-item left sc">
            <div className="vertical" />
            <div className="horizontal" />
            <div className="info">sc</div>
        </div>
        <div className="key-item right repeat" />
    </div>
);
